import React from 'react';
import { Redirect, matchPath, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { homeForRole } from './RoleRoute';

// Old URLs that may still live in bookmarks / installed Chrome-app shortcuts.
export const LEGACY_REDIRECTS = {
    '/HrDashboard': '/Nurse/Dashboard',
};

export const matchesAnyRoute = (pathname, routes) =>
    routes.some((el) => el && el.props && el.props.path && matchPath(pathname, {
        path: el.props.path,
        exact: el.props.exact,
        strict: el.props.strict,
        sensitive: el.props.sensitive,
    }));

const Fallback = ({ pathname }) => {
    const { isAuthenticated, loading, user } = useSelector((state) => state.auth);
    const legacy = Object.keys(LEGACY_REDIRECTS).find((p) => matchPath(pathname, { path: p, exact: true }));
    if (legacy) return <Redirect to={LEGACY_REDIRECTS[legacy]} />;
    if (loading) return null;
    return <Redirect to={isAuthenticated && user?.role ? homeForRole(user.role) : '/login'} />;
};

/**
 * Renders every child route as before (no <Switch>, so existing multi-match behaviour is kept)
 * and, when none of them matches the URL, redirects instead of leaving a blank page.
 */
const RoutesWithFallback = ({ children }) => {
    const { pathname } = useLocation();
    const matched = matchesAnyRoute(pathname, React.Children.toArray(children));
    return (
        <>
            {children}
            {!matched && <Fallback pathname={pathname} />}
        </>
    );
};

export default RoutesWithFallback;
